import React, { useEffect, useState } from "react";

import { Button, Box, Stack, Typography, Link } from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App/useAuth.jsx";
import { API_tokenSignInGoogle, APP_onSignOn, APP_onSignUp } from "../App/api.jsx";
import { ftchPlus, postOptions } from "../App/Account_urls.jsx";
import { TopBar } from "../Components/TopBar.jsx";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { GoogleAnalyticsUser } from "../Components/ga4.jsx";
import { MSClarityUser } from "../Components/clarity.jsx";
import { browserName, browserVersion } from "react-device-detect";
import { isDev } from "../Components/Environment";
import YouTubeIcon from "../Components/YouTubeIcon.jsx";



const betaTag = "(Open Beta)"
const betaDate = "January 31, 2024"
const betaEmail = "beta@myownfp.ca"
const supportEmail = "support@myownfp.ca"
// const airplaneMode = true

//export const availableTag = "(Free Period)"
export const freeTag = "(Free Period)"
const freeDate = "March 31, 2027"

export const availabilityTag = freeTag


const GoogleAccountSignup = () => {
  return (
    <Box sx={{ mt: 6, mx: 20, border: "1px solid blue" }}>
      <Typography
        variant="body1"
        gutterBottom={false}
        align="left"
        sx={{ mx: 2, my: 2 }}
        color="black"
      >
        If you do not have a Google account, create a Google account by following this link, (you can use an existing email for the account, it doesn't have to be a new gmail).  Then return to this tab, reload the page and sign in (top right Login button).
      </Typography>
      <Link
        href="https://accounts.google.com/signup"
        target="_blank"
        rel="noopener noreferrer"
      >
        Create Google Account
      </Link>
    </Box>
  )
}



const BetaPeriod = () => {
  return (
    <>
      {availabilityTag === betaTag && betaTag !== "" && (
        <Box sx={{ mt: 6, mx: 20, border: "1px solid green" }}>
          <Typography
            variant="body1"
            gutterBottom={false}
            align="left"
            sx={{ mx: 2, my: 2 }}
            color="black"
          >
            {"We are currently in open Beta trial, until at least " + betaDate + "."}<br />
            <br />
            Once you Sign in, you will be able to access all aspects of MyOwnFP for free for until the end of the beta period.<br />
            <br />
            {"Please send any questions, comments or suggestions to " + betaEmail}<br />
            <br />
            We're happy to answer any questions, as you create and personalize your Financial Plan with MyOwnFP.<br />
            <br />
            Enjoy!<br />
          </Typography>

        </Box>
      )}
    </>
  )
}






const FreePeriod = () => {
  return (
    <>
      {availabilityTag === freeTag && freeTag !== "" && (
        <Box sx={{ mt: 6, mx: 20, border: "1px solid green" }}>
          <Typography
            variant="body1"
            gutterBottom={false}
            align="left"
            sx={{ mx: 2, my: 2 }}
            color="black"
          >
            {"We are currently in a Free Period as we continue to expand our offerings. This will last until at least " + freeDate + "."}<br />
            <br />
            Once you Sign in, you will be able to access all aspects of MyOwnFP for free, until the end of the Free Period.<br />
            <br />
            {"Please send any questions, comments or suggestions to " + supportEmail}<br />
            <br />
            We're happy to answer any questions, as you create and personalize your Financial Plan with MyOwnFP.<br />
            <br />
            Enjoy!<br />
            {supportEmail}
          </Typography>

        </Box>
      )}
    </>
  )
}

const TestBrowser = ({ onUpgradeBrowser }) => {
  const [upgradeBrowser, setUpgradeBrowser] = useState(false)



  useEffect(() => {
    // test out various functions, see if browser upgrade is required
    console.log("Test Browser")
    console.log(browserName + " " + browserVersion)
    try {
      let y = "string"
      let x = structuredClone(y)
    } catch {
      console.log(browserName + " " + browserVersion)
      console.log("StructuredClone does not exist")
      setUpgradeBrowser(true)
      onUpgradeBrowser(true)
    }
  }, []);

  return (
    <>
      {upgradeBrowser && (
        <Box sx={{ mt: 6, mx: 20, border: "1px solid red" }}>

          <Typography
            variant="body1"
            gutterBottom={false}
            align="left"
            sx={{ mx: 2, my: 2 }}
            color="black"
          >
            Your current browser will not work with the MyOwnFP web application, you will need upgrade to a more recent browser version.<br />
            We have disabled the login button to avoid the application not working.<br />
            <br />
            Minimum Versions are:<br />
            <li>Chrome (98) </li>
            <li>Firefox (94) </li>
            <li>Edge (98) </li>
            <li>Safari (15.4) </li>
          </Typography>
        </Box>
      )}
    </>
  )
}








const SignIn = () => {
  const navigate = useNavigate();
  const { avatar_, login_, email_, subuuid_, startupHelp_, admin_, features_ } = useAuth();

  const [errmsg, setErrmsg] = useState("")
  const [upgradeBrowser, setUpgradeBrowser] = useState(false)



  function subscriberLogin(subscriber, subuuid, picture, email, startupHelp, admin, features) {
    console.log("login: " + subscriber);
    subuuid_(subuuid);
    login_(subscriber);
    avatar_(picture);
    email_(email);
    startupHelp_(startupHelp);
    admin_(admin);
    features_(features);
    MSClarityUser(subuuid)
    GoogleAnalyticsUser(subuuid);



  }
  // const AirplaneMode = () => {
  //   const Login = () => {
  //     postRequest("{credential: airplaneMode}")
  //   }
  //   return (
  //     <>
  //       (airplaneMode && (
  //       <Button variant="contained" onClick={Login} >
  //         Airplane Mode
  //       </Button>
  //       ))
  //     </>
  //   )
  // }

  const getSubscriber = () => {
    const subscriber = useAuth;
    return subscriber;
  };

  const SetUpgradeBrowser = (v) => {
    setUpgradeBrowser(v)
  }

  function postRequest(idToken) {
    var url = API_tokenSignInGoogle;
    var req = postOptions;
    var post = idToken;
    req.body = JSON.stringify(post);
    ftchPlus(url, req)

      .then((json) => {
        console.log("SI: pr" + json.Subscriber);
        console.log(json);
        subscriberLogin(
          json.Subscriber,
          json.SubUuid,
          json.Picture,
          json.Email,
          json.StartupHelp,
          json.Admin,
          json.Features,
        );
        if (json.Subscriber.new) {
          console.log("SI: newSUb");
          navigate(APP_onSignUp);
        } else {
          console.log("SI: exising");
          navigate(APP_onSignOn);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  }


  return (
    <>
      <TopBar text={availabilityTag}>
        <Box sx={{ justifyContent: "flex-start", pl: 4, display: "flex", flexGrow: 1 }}>
        </Box>
        <Box sx={{ justifyContent: "flex-end" }}>
          <Stack direction="row" spacing={2}>
            {/* <AirplaneMode /> */}
            <YouTubeIcon />
            {!upgradeBrowser && (
              <GoogleLogin
                onSuccess={(credentialResponse) => {
                  console.log(credentialResponse);
                  postRequest(credentialResponse);
                }}
                useOneTap
                theme="filled_blue"
                shape="circle"
                onError={() => {
                  console.log("Login Failed");
                  setErrmsg("Login Failed")
                }}
              />
            )}
          </Stack>
        </Box>
      </TopBar >
      <TestBrowser onUpgradeBrowser={SetUpgradeBrowser} />
      <BetaPeriod />
      <FreePeriod />
      <GoogleAccountSignup />
      <ErrorBar error={errmsg} />
    </>
  );
};




export default SignIn;




// export async function login(username, password) {
//   url = API_login
//   const res = await ftchPlus(url, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ username, password }),
//   });

//   if (res.status === 401) return {};

//   const user = await res.json();

//   return { user };
// }